// File: frontend/src/services/handoff.js
//
// WORKSPACE SWITCHING BETWEEN THE TWO PESAFII APPLICATIONS.
//
// pesafii.net and ambassador.pesafii.net each keep their own session (browsers
// keep localStorage per origin, and there is deliberately no shared
// .pesafii.net cookie). Moving between them signed in is a one-time handoff:
//
//   1. this app asks the API for a code bound to the destination (60 s, one use)
//   2. the browser goes to <destination>/auth/handoff#code=…  (fragment only)
//   3. the destination redeems it for its OWN normal session (auth/HandoffPage)
//
// If the person is not signed in here, or anything fails, this degrades to a
// plain navigation: the destination simply asks them to sign in. It never
// blocks the switch and never follows a URL the API returned for a different
// origin than the one asked for.

import { authHandoffService, authService } from "./api";
import { AMBASSADOR_ORIGIN, MAIN_ORIGIN, isSafeRelativePath } from "../config/origins";

const ORIGIN_FOR = { main: MAIN_ORIGIN, ambassador: AMBASSADOR_ORIGIN };

function hasSession() {
  try { return Boolean(localStorage.getItem("token")) && Boolean(authService.getCurrentUser()); }
  catch (_) { return false; }
}

/**
 * Open the other PesaFii application, signed in when possible.
 *   openWorkspace("ambassador", "/clients?open=12")
 *   openWorkspace("main", "/dashboard")
 */
export async function openWorkspace(destination, returnPath = "/") {
  const origin = ORIGIN_FOR[destination];
  if (!origin) throw new Error(`Unknown workspace: ${destination}`);
  const path = isSafeRelativePath(returnPath) ? returnPath : "/";
  const plain = `${origin}${path}`;

  if (!hasSession()) { window.location.assign(plain); return; }
  try {
    const res = await authHandoffService.issue(destination, path);
    const url = res?.success && typeof res.url === "string" ? new URL(res.url) : null;
    if (url && url.origin === origin && url.pathname === "/auth/handoff" && url.hash.startsWith("#code=")) {
      window.location.assign(url.toString());
      return;
    }
  } catch (_) {
    // Fall through: the destination will ask for a sign-in instead.
  }
  window.location.assign(plain);
}
